import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, Button, Menu, MenuItem, Toolbar } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { LogoUxBeauty } from './LogoUxBeauty';
import { UserMenuButton } from './UserMenuButton';

import { tss } from 'tss-react/mui';
import { useComponentSizeFixed } from 'hooks/useComponentSizeFixed';
import { NAVBAR_ID } from 'components/constants/Constants';
import { CartButton } from './CartButton';
import { CartDrawer } from '../contexts/cart/CartDrawer';

const getMenuItems = () => [
  { label: 'Our Ingredients', path: `/ingredients/search` },
  { label: 'Our Concepts', path: '/concepts/search' },
  { label: 'Meet us', path: '/meet-us' },
  { label: 'Trends & Science', path: '/trends-and-science' },
  { label: 'Press release', path: '/press-release' }
];
interface NavigationBarProps {
  setToolBarHeight: (height: number) => void;
}
export const NavigationBar: React.FC<NavigationBarProps> = props => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const navOpen = Boolean(anchorElNav);
  const { classes } = useStyles();
  const navRef = useRef(null);
  const { height } = useComponentSizeFixed(navRef);
  useEffect(() => {
    props.setToolBarHeight(height);
  }, [height, props]);
  return (
    <AppBar
      ref={navRef}
      id={NAVBAR_ID}
      sx={{
        background: 'white',
        zIndex: 1055 // TODO fix modals
      }}
      elevation={1}
    >
      <Toolbar className={classes.uxbNavWrapper}>
        <Box sx={{ flexGrow: 1 }}>
          <Link to="/">
            <Box
              sx={theme => ({
                width: 200,
                [theme.breakpoints.down('sm')]: {
                  width: 150,
                  marginTop: 1
                }
              })}
            >
              <LogoUxBeauty />
            </Box>
          </Link>
        </Box>
        <Box className={classes.menuSection}>
          <Box sx={{ display: { md: 'none' } }}>
            <Button color="primary" onClick={handleOpenNavMenu}>
              <MenuIcon />
              &nbsp;MENU
            </Button>
            <Menu
              anchorEl={anchorElNav}
              open={navOpen}
              onClose={handleCloseNavMenu}
            >
              {getMenuItems().map(item => (
                <MenuItem
                  type="button"
                  key={item.label}
                  component={Link}
                  to={item.path}
                  onClick={handleCloseNavMenu}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box
            sx={theme => ({
              display: { xs: 'none', md: 'flex' },
              gap: theme.spacing(1)
            })}
          >
            {getMenuItems().map(item => (
              <Button
                variant="text"
                key={item.label}
                component={NavLink}
                to={item.path}
                color="primary"
                sx={{
                  textTransform: 'none'
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          <Box
            sx={{
              ml: 3,
              gap: 0.5,
              display: 'flex'
            }}
          >
            <>
              <CartButton />
              <CartDrawer />
            </>

            <UserMenuButton />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
const useStyles = tss.create(({ theme }) => ({
  uxbNavWrapper: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  menuSection: {
    display: 'flex',
    alignContent: 'right',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: '8px 0'
    }
  }
}));
